import React from 'react';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';

import './textarea.scss';

const Textarea = ({
    input,
    label,
    meta,
    theme,
    onChange = false,
    ...rest
}) => (
        <div
            className={classnames('TextareaWrapper', theme, {
                hasError: meta && meta.error && meta.touched,
            })}
        >
            <label htmlFor={rest.id}>{label}</label>
            <div>
                <TextareaAutosize
                    data-tip={meta && meta.error ? meta.error : null}
                    rows={2}
                    maxRows={6}
                    onChange={e => onChange && onChange(e.currentTarget.value)}
                    {...input}
                    {...rest}
                />
            </div>
            {
                meta
                && meta.touched
                && meta.error
                && meta.active && (
                    <ReactTooltip
                        type="error"
                        effect="solid"
                        place="top"
                        event="focus"
                    />
                )}
        </div>
)


export default Textarea;
